import {getToken} from "@/utils/auth";
import {moduleList,moduleModify,categoryList,categoryModify,BaseDictionaryList,BaseDictionaryList_typeDDL} from "@/api/setting";
import {formatDataToSever} from "@/views/System/Setting/Module/module-xml-manager";
import {_isMobile} from  "@/utils/tools";

const state = {
    moduleList: [],
    categoryList:[],
    BaseDictionaryList:[],
    BaseDictionaryList_typeDDL:[],
    isMobile:false,
};

const mutations = {
    moduleList: (state, list) => {
        state.moduleList = list;
    },
    categoryList: (state, list) => {
        state.categoryList = list;
    },
    BaseDictionaryList: (state, list) => {
        state.BaseDictionaryList = list;
    },
    BaseDictionaryList_typeDDL: (state, list) => {
        state.BaseDictionaryList_typeDDL = list;
    },
    ISMOBILE: (state, isMobile) => {
        state.isMobile = isMobile
      },
}

const actions = {
    async moduleModify({commit}, {
        form
    }) {
        return moduleModify({
            userId: getToken(),
            ...formatDataToSever(form)
        }).then(response => {

        });
    },

    async moduleList({commit}, {userId} = {}) {
        const {data} = await moduleList({
            userId: userId || getToken()
        });
        commit('moduleList', data);
    },

    async categoryModify({commit}, {
        form
    }) {
        return categoryModify({
            userId: getToken(),
            ...form
        }).then(response => {

        });
    },

    async categoryList({commit}, {userId} = {}) {
        const {data} = await categoryList({
            userId: userId || getToken()
        });
        commit('categoryList', data);
    },
  
    async BaseDictionaryList({commit}, {key, typeCate} = {}) {
        const {data} = await BaseDictionaryList({
            userId: getToken(), key, typeCate
        });
        commit('BaseDictionaryList', data);
    },

    
    async BaseDictionaryList_typeDDL({commit}) {
        const {data} = await BaseDictionaryList_typeDDL({
            userId: getToken(),
        });
        commit('BaseDictionaryList_typeDDL', data);
    },

    checkDevice({commit}){
        var isMobile = _isMobile();
        // console.log('ismobile2222',isMobile)
        commit('ISMOBILE', isMobile)
      }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
